module.exports = __webpack_public_path__ + "static/img/banner_we_01.a603fac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/about/banner_we_01.png
// module id = L/Ph
// module chunks = 10